export const mobileMainContainer = {
    fontFamily: 'Lato, sans-serif',
    marginTop: 60
};

export const   mobileContainerPaper= {
    background: 'transparent',
    width: '100%',
    marginLeft: '-16px'
};



// WEBPACK FOOTER //
// ./src/styles/shared/mobile.js